import { Link, Outlet } from "react-router-dom";
import { Eye, UserPlus, PlusCircle, BookOpen, Info, HelpCircle, Shield, FileText } from "lucide-react";
import HamburgerMenu from "./HamburgerMenu";
import ConsentBanner from "./ConsentBanner";
import { useAnalytics } from "@/hooks/useAnalytics";

export default function Layout() {
  useAnalytics();

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <nav className="sticky top-0 z-50 border-b border-border bg-surface/80 backdrop-blur-md">
        <div className="mx-auto flex h-14 max-w-2xl items-center justify-between px-4">
          <Link
            to="/"
            className="flex items-center gap-1.5 font-display text-xl font-bold text-primary"
          >
            <Eye className="h-5 w-5" />
            ISPYFR
          </Link>
          <div className="flex items-center gap-2">
            <HamburgerMenu />
            <Link
              to="/join"
              className="inline-flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-base font-medium text-text-secondary transition-colors hover:bg-surface-sunken hover:text-text"
            >
              <UserPlus className="h-4 w-4" />
              Join
            </Link>
            <Link
              to="/create"
              className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-3 py-1.5 text-base font-medium text-text-inverse transition-colors hover:bg-primary-hover"
            >
              <PlusCircle className="h-4 w-4" />
              Create
            </Link>
          </div>
        </div>
      </nav>
      <main className="mx-auto w-full max-w-2xl flex-1 px-4 py-6">
        <Outlet />
      </main>
      <footer className="border-t border-border bg-surface/50">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-2 px-4 py-6 text-sm text-text-secondary sm:flex-row sm:justify-between">
          <p>&copy; {new Date().getFullYear()} South Fork Games. All rights reserved.</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 sm:justify-end">
            <Link to="/how-to-play" className="inline-flex items-center gap-1 hover:text-text">
              <BookOpen className="h-3.5 w-3.5" />
              How to Play
            </Link>
            <Link to="/about" className="inline-flex items-center gap-1 hover:text-text">
              <Info className="h-3.5 w-3.5" />
              About
            </Link>
            <Link to="/faq" className="inline-flex items-center gap-1 hover:text-text">
              <HelpCircle className="h-3.5 w-3.5" />
              FAQ
            </Link>
            <Link to="/privacy" className="inline-flex items-center gap-1 hover:text-text">
              <Shield className="h-3.5 w-3.5" />
              Privacy
            </Link>
            <Link to="/terms" className="inline-flex items-center gap-1 hover:text-text">
              <FileText className="h-3.5 w-3.5" />
              Terms
            </Link>
          </div>
        </div>
      </footer>
      <ConsentBanner />
    </div>
  );
}
